import * as React from 'react';

const SvgEmptySearch = (props) => (
  <svg
    width={166}
    height={143}
    viewBox="0 0 166 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M81.8323 120.541C114.981 120.541 141.856 93.6667 141.856 60.3994C141.856 27.1321 114.981 0.257812 81.8323 0.257812C48.6834 0.257812 21.8091 27.1321 21.8091 60.3994C21.8091 93.6667 48.6834 120.541 81.8323 120.541Z"
      fill="#EAEEF9"
    />
    <path
      d="M37.6731 28.5527H123.032C126.465 28.5527 129.069 31.1573 129.069 34.5906V88.6943C129.069 92.1276 126.465 94.7322 123.032 94.7322H37.6731C34.2398 94.7322 31.6353 92.1276 31.6353 88.6943V34.5906C31.6353 31.1573 34.4766 28.5527 37.6731 28.5527Z"
      fill="url(#paint0_linear_25_1669)"
    />
    <g filter="url(#filter0_d_25_1669)">
      <path
        d="M112.706 34.5862L113.432 92.997C113.432 94.9924 111.799 96.5343 109.804 96.5343H52.8438C50.8484 96.5343 49.2158 94.9017 49.2158 92.997V17.8974C49.2158 15.902 50.8484 14.3601 52.8438 14.3601H94.1123L112.706 34.5862Z"
        fill="url(#paint1_linear_25_1669)"
      />
    </g>
    <path
      d="M86.1307 26.6048H58.83C58.1951 26.6048 57.6509 26.0606 57.6509 25.4257C57.6509 24.7908 58.1951 24.2466 58.83 24.2466H86.1307C86.7656 24.2466 87.3098 24.7908 87.3098 25.4257C87.3098 26.0606 86.7656 26.6048 86.1307 26.6048Z"
      fill="#D5DDEA"
    />
    <path
      d="M69.3512 33.1353H58.83C58.1951 33.1353 57.6509 32.5911 57.6509 31.9562C57.6509 31.3213 58.1951 30.7771 58.83 30.7771H69.2605C69.8954 30.7771 70.4396 31.3213 70.4396 31.9562C70.4396 32.5911 69.8954 33.1353 69.3512 33.1353Z"
      fill="#D5DDEA"
    />
    <path
      d="M94.1123 14.3601V30.5047C94.1123 32.7722 96.1077 34.5862 98.3752 34.5862H112.706"
      fill="#D5DDEA"
    />
    <path
      d="M105.106 46.9275H95.2087H92.7554H59.1711C58.7482 46.9275 58.3252 47.3514 58.3252 47.9448C58.3252 48.4534 58.6636 48.9621 59.1711 48.9621H92.7554H95.2087H105.022C105.614 48.9621 105.952 48.5382 105.952 47.9448C105.952 47.4361 105.614 46.9275 105.106 46.9275Z"
      fill="#D5DDEA"
    />
    <path
      d="M130.727 63.2408V89.8784C130.727 93.3116 128.004 96.153 124.452 96.153H36.7258C33.2926 96.153 30.4512 93.3116 30.4512 89.8784V60.9915"
      stroke="#1676EE"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M123.268 48.3237H95.5656C92.8426 48.3237 90.2381 49.2708 88.2255 50.9283L81.0037 56.8477C78.9911 58.5052 76.3866 59.4523 73.6636 59.4523H42.4089C39.2124 59.4523 36.6079 62.0569 36.6079 65.2534C36.6079 65.4901 36.6079 65.8453 36.7263 66.0821L42.5273 96.6264C43.0009 99.4678 45.3686 101.599 48.3284 101.599H115.218C118.059 101.599 120.545 99.5862 121.019 96.7448L129.069 54.9535C129.661 51.757 127.53 48.9157 124.334 48.3237C123.86 48.3237 123.505 48.3237 123.268 48.3237Z"
      fill="white"
    />
    <g filter="url(#filter1_d_25_1669)">
      <path
        d="M135.699 40.1548H99.709C96.1573 40.1548 92.8424 41.3387 90.1195 43.588L80.6484 51.2833C78.0438 53.4143 74.6105 54.7166 71.0588 54.7166H30.333C26.1894 54.7166 22.8745 58.1499 22.8745 62.1751C22.8745 62.5303 22.8745 62.8854 22.9929 63.2406L30.4514 103.138C31.0434 106.926 34.2399 109.649 37.9099 109.649H125.044C128.833 109.649 131.911 107.045 132.503 103.256L143.039 48.6788C143.75 44.5352 141.027 40.8651 136.883 40.0364C136.528 40.1548 136.054 40.1548 135.699 40.1548Z"
        fill="url(#paint2_linear_25_1669)"
      />
    </g>
    <path
      d="M140.083 36.1473C142.347 36.1473 144.183 34.3116 144.183 32.0473C144.183 29.7829 142.347 27.9473 140.083 27.9473C137.819 27.9473 135.983 29.7829 135.983 32.0473C135.983 34.3116 137.819 36.1473 140.083 36.1473Z"
      fill="#EAEEF9"
    />
    <path
      d="M135.983 22.8471C137.529 22.8471 138.783 21.5935 138.783 20.0471C138.783 18.5007 137.529 17.2471 135.983 17.2471C134.437 17.2471 133.183 18.5007 133.183 20.0471C133.183 21.5935 134.437 22.8471 135.983 22.8471Z"
      fill="#EAEEF9"
    />
    <path
      d="M22.5832 32.0473C24.1296 32.0473 25.3832 30.7937 25.3832 29.2473C25.3832 27.7009 24.1296 26.4473 22.5832 26.4473C21.0368 26.4473 19.7832 27.7009 19.7832 29.2473C19.7832 30.7937 21.0368 32.0473 22.5832 32.0473Z"
      fill="#EAEEF9"
    />
    <path
      d="M16.283 93.6471C19.1549 93.6471 21.483 91.3189 21.483 88.4471C21.483 85.5752 19.1549 83.2471 16.283 83.2471C13.4111 83.2471 11.083 85.5752 11.083 88.4471C11.083 91.3189 13.4111 93.6471 16.283 93.6471Z"
      fill="#EAEEF9"
    />
    <path
      d="M134.5 117.457L117.106 100.098C98.7467 113.6 73.5747 100.436 73.5747 78.3994C73.5747 63.4031 85.7983 51.2517 100.776 51.2517C122.421 51.2517 135.707 75.5544 123.097 93.9261L140.587 111.382C142.278 113.069 142.278 115.77 140.587 117.457C138.896 119.145 136.191 119.145 134.5 117.457ZM100.776 59.883C90.5332 59.883 82.1747 68.225 82.1747 78.4476C82.1747 94.8905 101.887 102.799 113.193 92.2384C125.996 80.28 117.444 59.883 100.776 59.883Z"
      fill="#989FB0"
    />
    <path
      d="M98.8916 82.4982C98.8432 82.1124 98.7949 81.7266 98.7949 81.2927C98.7949 79.7014 99.4713 78.2548 101.162 77.0011L102.612 75.9403C103.53 75.2652 103.916 74.4937 103.916 73.5775C103.916 72.2274 102.95 70.9254 100.921 70.9254C98.7949 70.9254 97.8769 72.6131 97.8769 74.3008C97.8769 74.6383 97.9253 74.9759 97.9736 75.2652L94.205 75.1205C94.1084 74.6866 94.0601 74.2044 94.0601 73.7704C94.0601 70.5397 96.4758 67.4536 100.873 67.4536C105.511 67.4536 107.927 70.3468 107.927 73.3846C107.927 75.7474 106.719 77.3869 104.979 78.6406L103.771 79.5085C102.709 80.2318 102.177 81.1962 102.177 82.4017V82.5946H98.8916V82.4982ZM100.583 84.4269C101.887 84.4269 102.95 85.4878 102.95 86.7897C102.95 88.0916 101.887 89.1525 100.583 89.1525C99.2781 89.1525 98.2151 88.0916 98.2151 86.7897C98.2151 85.4878 99.2781 84.4269 100.583 84.4269Z"
      fill="#989FB0"
    />
    <defs>
      <filter
        id="filter0_d_25_1669"
        x={27.2158}
        y={3.3601}
        width={108.216}
        height={126.174}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_25_1669"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_25_1669"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_25_1669"
        x={0.874512}
        y={29.0364}
        width={164.277}
        height={113.613}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_25_1669"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_25_1669"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_25_1669"
        x1={80.36}
        y1={30.8517}
        x2={80.36}
        y2={67.9976}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0BACC" />
        <stop offset={1} stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_25_1669"
        x1={81.3027}
        y1={12.4593}
        x2={81.3027}
        y2={97.4202}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_25_1669"
        x1={82.974}
        y1={38.4262}
        x2={82.974}
        y2={110.4}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgEmptySearch;
